import React from 'react';

interface TabItem {
  label: string;
  value?: string;
}

interface TabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  className?: string;
  tabClassName?: string;
  activeTabClassName?: string;
  inactiveTabClassName?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
  tabClassName = '',
  activeTabClassName = '',
  inactiveTabClassName = '',
}) => {
  return (
    <div
        className={`w-full overflow-x-auto rounded-2xl border border-slate-200/60 bg-slate-100/90 p-1 backdrop-blur-md sm:inline-flex sm:w-auto shadow-xs ${className}`}
    >
      <div className='flex min-w-max gap-1'>
        { tabs.map(({ label, value }) => {
          const isActive = activeTab === (value ?? label);
          return (
            <button
                key={label}
                className={`
                min-h-8 sm:min-h-9 whitespace-nowrap px-4 sm:px-5 py-1.5 text-xs sm:text-[13px] rounded-xl transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]
                ${tabClassName}
                ${
                  isActive
                    ? `bg-white text-slate-900 font-semibold shadow-[0_2px_8px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] ring-1 ring-black/[0.04] ${activeTabClassName}`
                    : `text-slate-500 hover:text-slate-900 font-medium hover:bg-white/40 ${inactiveTabClassName}`
                }
              `}
                onClick={() => onTabChange(value ?? label)}
            >
              { label }
            </button>
          );
        }) }
      </div>
    </div>
  );
};
